import { render, staticRenderFns } from "./Notepad.vue?vue&type=template&id=0aa3e87e&scoped=true&"
import script from "./Notepad.vue?vue&type=script&lang=ts&"
export * from "./Notepad.vue?vue&type=script&lang=ts&"
import style0 from "./Notepad.vue?vue&type=style&index=0&id=0aa3e87e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa3e87e",
  null
  
)

export default component.exports